<template>
    <div v-if="showInsurance">
      <message
        v-if="isLoading "
        class="mt-5 d-flex justify-content-center"
        loading
        message="產險資料讀取中，請稍候..."
      />
      <div v-else>
        <!-- ---------國泰產險-健康險--------- -->
        <cathay-property-health-insurance
          v-if="isEdit"
          :datas="getCathayPropertyInsuranceDatas(cathayHealthInsurance)"
          :_fields="fieldOption.ACTION_ONE"
          ref="cathay-property-health-insurance"
        >
        </cathay-property-health-insurance>
        <cathay-property-health-insurance
          v-else
          :datas="getCathayPropertyInsuranceDatas(cathayHealthInsurance)"
          ref="cathay-property-health-insurance"
        >
        </cathay-property-health-insurance>
        <!-- ---------國泰產險-傷害險--------- -->
        <cathay-property-hurt-insurance
          v-if="isEdit"
          :datas="getCathayPropertyInsuranceDatas(cathayHurtInsurance)"
          :_fields="fieldOption.ACTION_ONE"
          ref="cathay-property-hurt-insurance"
        >
        </cathay-property-hurt-insurance>
        <cathay-property-hurt-insurance
          v-else
          :datas="getCathayPropertyInsuranceDatas(cathayHurtInsurance)"
          ref="cathay-property-hurt-insurance"
        >
        </cathay-property-hurt-insurance>
        <!-- ---------國泰產險-新種險--------- -->
        <cathay-property-new-insurance
          v-if="isEdit"
          :datas="getCathayPropertyInsuranceDatas(cathayNewInsurance)"
          :_fields="fieldOption.ACTION_ONE"
          ref="cathay-property-new-insurance"
        >
        </cathay-property-new-insurance>
        <cathay-property-new-insurance
          v-else
          :datas="getCathayPropertyInsuranceDatas(cathayNewInsurance)"
          ref="cathay-property-new-insurance"
        >
        </cathay-property-new-insurance>
        <!-- ---------其他產險-新種險--------- -->
        <!-- <other-property-new-insurance
          v-if="isEdit"
          :datas="getOtherPropertyInsuranceDatas(otherNewInsurance)"
          :_fields="fieldOption.ACTION_DROPDOWN"
          ref="other-property-new-insurance"
        >
        </other-property-new-insurance>
        <other-property-new-insurance
          v-else
          :datas="getOtherPropertyInsuranceDatas(otherNewInsurance)"
          ref="other-property-new-insurance"
        >
        </other-property-new-insurance> -->
        <!-- ---------其他產險-其他 保單筆記--------- -->
        <!-- <other-property-insurance-note
          v-if="isEdit"
          :datas="getOtherPropertyInsuranceDatas(otherInsuranceNote)"
          :_fields="fieldOption.ACTION_DROPDOWN"
          ref="other-property-insurance-note"
        >
        </other-property-insurance-note>
        <other-property-insurance-note
          v-else
          :datas="getOtherPropertyInsuranceDatas(otherInsuranceNote)"
          ref="other-property-insurance-note"
        >
        </other-property-insurance-note> -->
        <!-- ---------國泰產險-車險--------- -->
        <cathay-property-car-insurance
          v-if="isEdit"
          :datas="getCathayPropertyInsuranceDatas(cathayCarInsurance)"
          :_fields="fieldOption.ACTION_ONE"
          ref="cathay-property-car-insurance"
        >
        </cathay-property-car-insurance>
        <cathay-property-car-insurance
          v-else
          :datas="getCathayPropertyInsuranceDatas(cathayCarInsurance)"
          ref="cathay-property-car-insurance"
        >
        </cathay-property-car-insurance>
        <!-- ---------國泰產險-火險--------- -->
        <cathay-property-fire-insurance
          v-if="isEdit"
          :datas="getCathayPropertyInsuranceDatas(cathayFireInsurance)"
          :_fields="fieldOption.ACTION_ONE"
          ref="cathay-property-fire-insurance"
        >
        </cathay-property-fire-insurance>
        <cathay-property-fire-insurance
          v-else
          :datas="getCathayPropertyInsuranceDatas(cathayFireInsurance)"
          ref="cathay-property-fire-insurance"
        >
        </cathay-property-fire-insurance>
        <!-- ---------其他產險-車險--------- -->
        <!-- <other-property-car-insurance
          v-if="isEdit"
          :datas="getOtherPropertyInsuranceDatas(otherCarInsurance)"
          :_fields="fieldOption.ACTION_DROPDOWN"
          ref="other-property-car-insurance"
        >
        </other-property-car-insurance>
        <other-property-car-insurance
          v-else
          :datas="getOtherPropertyInsuranceDatas(otherCarInsurance)"
          ref="other-property-car-insurance"
        >
        </other-property-car-insurance> -->
        <!-- ---------其他產險-火險--------- -->
        <!-- <other-property-fire-insurance
          v-if="isEdit"
          :datas="getOtherPropertyInsuranceDatas(otherFireInsurance)"
          :_fields="fieldOption.ACTION_DROPDOWN"
          ref="other-property-fire-insurance"
        >
        </other-property-fire-insurance>
        <other-property-fire-insurance
          v-else
          :datas="getOtherPropertyInsuranceDatas(otherFireInsurance)"
          ref="other-property-fire-insurance"
        >
        </other-property-fire-insurance> -->
        <message
          v-if="showNoDataMsg && !hasPropertyInsurance && !memberObj"
          message="此家戶尚未有任何產險保單"
        />

        <message
          v-if="showNoDataMsg && !hasPropertyInsurance && memberObj"
          message="無可查詢資料"
        />
      </div>
    </div>
</template>

<script>
import CathayPropertyHealthInsurance from "./CathayPropertyHealthInsurance";
import CathayPropertyHurtInsurance from "./CathayPropertyHurtInsurance";
import CathayPropertyNewInsurance from "./CathayPropertyNewInsurance";
// import OtherPropertyNewInsurance from "./OtherPropertyNewInsurance";
import CathayPropertyCarInsurance from "./CathayPropertyCarInsurance";
import CathayPropertyFireInsurance from "./CathayPropertyFireInsurance";
// import OtherPropertyCarInsurance from "./OtherPropertyCarInsurance";
// import OtherPropertyFireInsurance from "./OtherPropertyFireInsurance";
// import OtherPropertyInsuranceNote from "./OtherPropertyInsuranceNote.vue"; 
import Message from "./Message";

const EMPTY_CATHAY_PROPERTY_INSURANCE = { policies: [], policiesSelfInput: [] };

export default {
  components: {
    CathayPropertyHealthInsurance,
    CathayPropertyHurtInsurance,
    CathayPropertyNewInsurance,
    // OtherPropertyNewInsurance,
    CathayPropertyCarInsurance,
    CathayPropertyFireInsurance,
    // OtherPropertyCarInsurance,
    // OtherPropertyFireInsurance,
    // OtherPropertyInsuranceNote,
    Message,
  },
  props: {
    memberObj: {
      type: Object,
      default: null,
    },
    allFamilyDatas: {
      type: Array,
      default: new Array(),
    },
    showInsurance: {
      type: Boolean,
      default: true,
    },
    showNoDataMsg: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    isLoaded: {
      type: Boolean,
      default: false,
    },
    cathayHealthInsurance: {
      type: Object,
      default() { return {} }
    },
    cathayHurtInsurance: {
      type: Object,
      default() { return {} }
    },
    cathayNewInsurance: {
      type: Object,
      default() { return {} }
    },
    cathayCarInsurance: {
      type: Object,
      default() { return {} }
    },
    cathayFireInsurance: {
      type: Object,
      default() { return {} }
    },
    // otherInsuranceNote: {
    //   type: Array,
    //   default() { return [] }
    // },
    // otherNewInsurance: {
    //   type: Array,
    //   default() { return [] }
    // },
    // otherCarInsurance: {
    //   type: Array,
    //   default() { return [] }
    // },
    // otherFireInsurance: {
    //   type: Array,
    //   default() { return [] }
    // },
  },
  data: () => ({}),
  watch: {
  },
  computed: {
    fieldOption() {
      const ACTION_INIT_OPTION = {
        key: "action",
        name: "編輯",
        className: "text-center",
        thClassName: "text-center",
      };
      return {
        ACTION_ONE: { ...ACTION_INIT_OPTION, width: 80 },
        ACTION_DROPDOWN: { ...ACTION_INIT_OPTION, width: 30 },
      };
    },
    allFamilyCsidno: function() {
      return this.allFamilyDatas.map(x => x.csidno);
    },
    clickMember() {
      console.log("clickMember", this.memberObj.csidno || this.memberObj.serNo)
      return this.memberObj.csidno || this.memberObj.serNo;
    },
    hasPropertyInsurance: function() {
      return this.getCathayPropertyInsuranceDatas(this.cathayHealthInsurance).length > 0
          || this.getCathayPropertyInsuranceDatas(this.cathayHurtInsurance).length > 0
          || this.getCathayPropertyInsuranceDatas(this.cathayNewInsurance).length > 0
          || this.getCathayPropertyInsuranceDatas(this.cathayCarInsurance).length > 0
          || this.getCathayPropertyInsuranceDatas(this.cathayFireInsurance).length > 0
          // || this.getOtherPropertyInsuranceDatas(this.otherInsuranceNote).length > 0
          // || this.getOtherPropertyInsuranceDatas(this.otherNewInsurance).length > 0
          // || this.getOtherPropertyInsuranceDatas(this.otherCarInsurance).length > 0
          // || this.getOtherPropertyInsuranceDatas(this.otherFireInsurance).length > 0;
    },
  },
  methods: {
    assignFamilyInfo(datas) {
        return datas.filter(x => x).map((data) => {
            const { ceisdno, CEISDNO } = data;
            const targetProp = ceisdno || CEISDNO;
            //查詢家戶取家戶成員的排序,年齡
            if (this.allFamilyCsidno[targetProp]) {
                data.familyorder = this.allFamilyCsidno[targetProp].familyorder;
                data.familyrl = this.allFamilyCsidno[targetProp].familyrl;
                data.age = this.allFamilyCsidno[targetProp].age;
                data.ceisdnoorder = this.allFamilyCsidno[targetProp].csidno.replace(/~/, '');
            }
            //經手收費保單（body.policies）與 自行輸入保單（body.policiesselfinput）排序使用
            data.orderbBySelf = data.isKeyinBySelf ? 1 : 0;
            return data;
        });
    },
    //是否為自行輸入保單
    assignKeyinBySelf(datas) {
        return datas ? datas.map((x) => ((x.isKeyinBySelf = true), x)) : [];
    },
    filterBeforePolicies(policies) {
      //當天之前失效保單不顯示
      const toDay = new Date();
      return policies
        ? policies.filter(
            (item) => new Date(item.CELPSDT || item.celpsdt) > toDay
          )
        : [];
    },
    getInsurance() {
      this.$bus.emit(
        "property-insurance.get",
        () => { 
          console.log("property-insurance.get", this);
          this.isPropertyLoading = false}
      );
    },
    getCathayPropertyInsuranceDatas(insurance) {
      if (!insurance) insurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
      if (this.isEdit) {
        return [].concat(
          this.assignKeyinBySelf(insurance.policiesselfinput)
        )
      }

      let result = this.assignFamilyInfo(
        [].concat(
          this.filterBeforePolicies(insurance.policies),
          this.assignKeyinBySelf(this.filterBeforePolicies(insurance.policiesselfinput))
        )
      );
      if (this.memberObj) {
        result = result.filter((el) => this.clickMember.includes(el.ceisdno));
      }
      return result;
    },
    // getOtherPropertyInsuranceDatas(insurance) {
    //   if (!insurance) insurance = [];
    //   if (this.isEdit) {
    //     return [].concat(
    //       this.assignFamilyInfo(insurance)
    //     )
    //   }
      
    //   let result = this.assignFamilyInfo(
    //     [].concat(
    //       this.filterBeforePolicies(insurance)
    //     )
    //   );
    //   if (this.memberObj) {
    //     result = result.filter((el) => this.clickMember.includes(el.ceisdno));
    //   }
    //   return result;
    // }
  },
  created() {
    if (this.showInsurance && this.isLoading) {
      this.getInsurance();
    }
  },
  mounted() {},
}
</script>